// A deal's documents, as the upload queue speaks of them (useAttachmentUploads.js): the queue's
// word is an attachment, a deal's is a document. Used where a file uploads at once - the deal's
// page - and where it waits for the deal to exist - the form that creates one (TX-US-0039).

import { confirmDocumentUpload, requestDocumentUpload } from '../api.js';
import { contentTypeOf, validateDealFile } from './dealFiles.js';
import { typeOf } from './documentTypes.js';

export const DEAL_DOCUMENTS_API = {
  request: async (preDealId, file) => {
    const contract = await requestDocumentUpload(
      preDealId, file, contentTypeOf(file), typeOf(file),
    );
    return { ...contract, attachment: { attachment_id: contract.document.document_id } };
  },
  confirm: confirmDocumentUpload,
  validate: validateDealFile,
};
